import { memo } from 'react'
import { Skeleton } from '../Skeleton'

interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  error?: boolean
  // Shows a pulsing placeholder in the textarea's shape while its value loads
  skeleton?: boolean
}

export const Textarea = memo(({ error, skeleton, className, ...rest }: TextareaProps) => {
  if (skeleton) {
    return <Skeleton shape="textarea" />
  }
  const classes = ['form-control', error ? 'form-control--error' : '', className ?? '']
    .filter(Boolean)
    .join(' ')
  return <textarea className={classes} {...rest} />
})

Textarea.displayName = 'Textarea'
